module.exports = __webpack_public_path__ + "static/img/icon_QQ.c74e0e21.png";